import React from 'react'
import { AIRDROP_CONFIG } from '@/config'
import { Anchor, Text } from '@mantine/core'

const AirdropGuideLink: React.FC = () => {
  return (
    <Anchor href={AIRDROP_CONFIG.guideUrl} underline={false} target="_blank">
      <Text sx={(t) => ({ color: t.colors.gray[7] })} inline>
        Who qualifies for the airdrop? &rarr;
      </Text>
    </Anchor>
  )
}

export { AirdropGuideLink }
